export * from './Component_CurrencyValue';